import Sheet from "react-modal-sheet";
import { Icon } from "@iconify/react";
// iOS keyboard is now handled via CSS dvh units and viewport meta tag
import "./Modal.css";

const Modal = ({
  children,
  showModal,
  closeButton = true,
  onCloseModal,
  unCheckWarningModal,
  unCheckWarningCancelModal,
  duplicateEntry,
  cancelledModel,
  faddedBg,
  disableScrollLocking = false,
}) => {
  return (
    <div>
      <Sheet isOpen={showModal} onClose={onCloseModal} detent="content-height">
        <Sheet.Container
          className={
            (duplicateEntry
              ? "duplicateEntryModal"
              : cancelledModel
              ? "cancelledCheckedInModal"
              : "") +
            " " +
            (unCheckWarningModal || unCheckWarningCancelModal ? "bg-fade" : "")
          }
          disableScrollLocking={disableScrollLocking}
        >
          {/* Floating close button above modal */}
          {closeButton && (
            <button className="modal-close-above" onClick={onCloseModal} aria-label="Close">
              <Icon
                icon="iconamoon:close"
                className="modal-close-above__icon"
                width="24"
                height="24"
              />
            </button>
          )}

          <Sheet.Header>
            <div className="modal-top-line" />
          </Sheet.Header>

          <Sheet.Content disableDrag>{children}</Sheet.Content>
        </Sheet.Container>
        <Sheet.Backdrop className={faddedBg ? "faddedBg" : ""} onTap={onCloseModal}/>
      </Sheet>
    </div>
  );
};

export default Modal;